export default __webpack_public_path__ + "static/media/olasupo.eb5693bb.png";